export const hasValue = (value) => value !== null && value !== undefined

export function formatAuthoritativeAmount(amount, currency) {
  if (!hasValue(amount) || !currency) return 'Evidence unavailable'
  const number = Number(amount)
  if (!Number.isFinite(number)) return 'Evidence unavailable'
  try {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency', currency, currencyDisplay: 'code', maximumFractionDigits: 2,
    }).format(number)
  } catch (_) {
    return `${new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(number)} ${currency}`
  }
}

export function formatEvidenceDate(value) {
  if (!value) return null
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC',
  }).format(new Date(value))
}

export const humanize = (value) => value
  ? String(value).toLowerCase().replaceAll('_', ' ').replace(/^\S/, (letter) => letter.toUpperCase())
  : null
